import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { AlertCircleIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import clsx from 'clsx'

export type InputSubtitleProps = {
  text: string,
  className?: string
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    marginLeft: mutualTheme.spacing(1),
    color: mutualTheme.palette.textGray2.main
  }
})

export const InputSubtitle: React.FC<InputSubtitleProps> = (props) => {
  const { text, className } = props
  const classes = useStyles()

  return (
    <Box className={clsx([classes.container, className])}>
      <AlertCircleIcon htmlColor={mutualTheme.palette.textGray2.main} />
      <Typography variant='caption' className={classes.text}>{text}</Typography>
    </Box>
  )
}
